import { set, get } from '../lib/storage/expirableLocalStorage'

// When changing the structure of local storage item change the key so that
// errors are not created on users browsers.
const KEY = 'historicalActionsV1'
const TTL_ONE_DAY_IN_SECONDS = 24 * 60 * 60 // 86400 seconds

export function storeHistoricalActions(actions: Array<App.HistoricalAction>): void {
  return set(KEY, actions, TTL_ONE_DAY_IN_SECONDS)
}

export function retrieveHistoricalActions(): Array<App.HistoricalAction> | null {
  try {
    return get(KEY) || null
  } catch {
    // If parsing fails, return null
    return null
  }
}
